import { ValidationError } from './validation-error.model';

export class ValidatorResult<T> {
  public errors: ValidationError[];
  public model?: T;

  constructor(model?: T, errors?: ValidationError[]) {
    this.model = model;
    this.errors = errors ? errors : new Array<ValidationError>();
  }

  public isValid(): boolean {
    return !this.errors || this.errors.length === 0;
  }
}
